import User from 'account/dto/User'
import SettingDto from 'administration/dto/SettingDto'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ContactDto from 'referencial/components/contact/dto/ContactDto'
import i18n from 'simple-react-i18n'
import Toastr from 'toastr/components/Toastr'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import AdministrationHomePageModal from '../../administration/components/homepage/AdministrationHomePageModal'
import SieauParameterDto from '../../administration/dto/SieauParameterDto'
import Popup from '../../components/modal/Popup'
import Wait from '../../components/progress/Wait'
import {
    applicationName,
    formationUrl,
    supportUrl,
} from '../../conf/SieauConstants'
import aquasysLogoPath from 'assets/pictures/logoaQuasys.png'
import AppStore from '../../store/AppStore'
import { getSetting } from '../../utils/SettingUtils'
import ContactMailDialog from './mail/ContactMailDialog'
import { cacheChecker } from 'utils/CacheChecker'
import IssueDialog from './issue/IssueDialog'
import HelpIcon from '@mui/icons-material/Help'
import LiveHelpIcon from '@mui/icons-material/LiveHelp'
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew'
import BugReportIcon from '@mui/icons-material/BugReport'
import SettingsOverscanIcon from '@mui/icons-material/SettingsOverscan'; import MapIcon from '@mui/icons-material/Map'
import { Grid, SpeedDial, SpeedDialAction } from '@mui/material'
import { useScreenshot } from 'use-react-screenshot'
import useBoolean from 'utils/customHook/useBoolean'
import { useLocation } from 'react-router'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'

const BubbleHelp = ({
    refScreenshot,
}) => {
    const location = useLocation()

    const [isHovered, setIsHovered] = useState(false)
    const {
        value: isOpen,
        setTrue: handleOpen,
        setFalse: handleClose,
    } = useBoolean(false)
    const [isOpenMail, setIsOpenMail] = useState(false)
    const [isOpenAdmin, setIsOpenAdmin] = useState(false)
    const [isOpenIssue, setIsOpenIssue] = useState(false)
    const [email, setEmail] = useState('')

    const [image, takeScreenshot] = useScreenshot()

    const getImage = async () => await takeScreenshot(refScreenshot.current)

    const dispatch = useDispatch()

    const timeoutRef = useRef(null)

    const {
        settings,
        popup,
        accountUser,
        contacts,
        applicationSettings,
        helpLink,
    } = useSelector(store => ({
        settings: store.AdministrationReducer.settings,
        popup: store.SieauReducer.popup,
        accountUser: store.AccountReducer.accountUser,
        contacts: store.ContactReducer.contacts,
        applicationSettings: store.AdministrationReducer.applicationSettings,
        helpLink: store.HomeReducer.helpLink,
    }), shallowEqual)

    useEffect(() => {
        // cacheChecker()
        dispatch(AdministrationAction.fetchApplicationSettings())
    }, [dispatch])

    useEffect(() => {
        cacheChecker(true)
    }, [location.pathname])

    useEffect(() => {
        document.title = getSetting(applicationSettings, 'applicationName') || applicationName
        $('#favicon').attr('href', getSetting(applicationSettings, 'applicationFavicon') || aquasysLogoPath)
    }, [applicationSettings])

    useEffect(() => {
        if (contacts.length && accountUser.contactCode) {
            const findContact = contacts.find(o => o.code == accountUser.contactCode)
            setEmail(findContact ? findContact.email : '')
        } else if (email !== '') {
            setEmail('')
        }
    }, [contacts, accountUser.contactCode])

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }
        setIsHovered(true)
        handleOpen()
    }

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setIsHovered(false)
            handleClose()
        }, 500)
    }

    useEffect(() => {
        handleClose()
    }, [isOpenIssue, isOpenMail, isOpenAdmin])

    const formationToken = useApplicationSetting('formationToken')

    const pathFormation = helpLink.formationPath || helpLink.module || ''
    const formationLink = `${formationUrl}/${pathFormation}?tmp=${formationToken}`

    const pathNumber = (helpLink.number && helpLink.module) ? `/help-${helpLink.number}` : ''
    const helpOnlineLink = `${supportUrl}v7/${helpLink.module}${pathNumber}?tmp=${formationToken}`


    const actions = [
        { icon: <LiveHelpIcon />, name: i18n.goToOnlineHelp, onClick: () => window.open(helpOnlineLink, '_blank') },
        { icon: <AccessibilityNewIcon />, name: i18n.goToOnlineFormation, onClick: () => window.open(formationLink, '_blank') },
        { icon: <BugReportIcon />, name: i18n.bugReport,
            onClick: () => {
                setIsOpenIssue(true)
                getImage()
            } },
        settings.length && location.pathname === '/' && { icon: <SettingsOverscanIcon />, name: i18n.editView, onClick: () => setIsOpenAdmin(true) },
        { icon: <MapIcon />, name: i18n.sitePlan, onClick: () => window.open('#/sitePlan', 'newwindow', 'width=800,height=900') },
    ].filter(Boolean)

    const showBubbleHelp = location.pathname !== '/login' && location.pathname !== '/reset' && location.pathname !== '/unauthorized' && location.pathname !== '/sitePlan'

    return (
        <>
            {showBubbleHelp && (
                <Grid container onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
                    <SpeedDial
                        ariaLabel='BubbleHelp'
                        sx={{
                            position: 'fixed',
                            bottom: 16,
                            right: 10,
                            transform: isHovered ? 'translateX(0px)' : 'translateX(30px)',
                            transition: 'transform 0.3s ease',
                        }}
                        icon={<HelpIcon />}
                        FabProps={{
                            sx: {
                                width: isHovered ? 50 : 25,
                                height: 50,
                                borderRadius: isHovered ? 20 : 2,
                            },
                        }}
                        open={isOpen}
                    >
                        {actions.map((action) => (
                            <SpeedDialAction
                                key={action.name}
                                icon={action.icon}
                                onClick={() => {
                                    action.onClick?.()
                                }}
                                slotProps={{
                                    fab: {
                                        sx: {
                                            margin: '8px 0',
                                            width: '50px',
                                            height: '50px',
                                            boxShadow: '0px 2px 18px 0px rgba(0, 0, 0, 0.16)',
                                            border: 'solid 1px rgba(0, 0, 0, 0.2)',
                                        },
                                    },
                                    tooltip: {
                                        title: (
                                            <span style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}>
                                                {action.name}
                                            </span>
                                        ),
                                        open: true,
                                    },
                                }}
                            />
                        ))}
                    </SpeedDial>
                </Grid>
            )}
            <Toastr store={AppStore} />
            <Wait />
            <Popup
                header={popup?.header}
                actions={popup?.actions}
                idPopup='generalPopup'
            >
                {popup?.content}
            </Popup>
            <AdministrationHomePageModal isOpen={isOpenAdmin} setIsOpen={setIsOpenAdmin} />
            <ContactMailDialog
                isOpen={isOpenMail}
                setIsOpen={setIsOpenMail}
                email={email}
                setEmail={setEmail}
            />
            <IssueDialog isOpen={isOpenIssue} setIsOpen={() => setIsOpenIssue(false)} email={email} screenshot={image} user={accountUser.login}/>
        </>
    )
}

BubbleHelp.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        href: PropTypes.string,
    }),
    settings: PropTypes.arrayOf(PropTypes.instanceOf(SettingDto)),
    popup: PropTypes.element,
    accountUser: PropTypes.instanceOf(User),
    contacts: PropTypes.arrayOf(PropTypes.instanceOf(ContactDto)),
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    helpLink: PropTypes.shape({
        module: PropTypes.string,
        number: PropTypes.string,
        formationPath: PropTypes.string,
    }),
    refScreenshot: PropTypes.shape({ current: PropTypes.any }),
}

export default BubbleHelp
